import { createUseStyles } from 'react-jss';

export default createUseStyles({
  rowContainer: {
    width: '100%',
    alignSelf: 'baseline',
    overflowX: 'scroll',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    padding: '10px 20px',
    margin: '5px 0',
    display: 'flex',
    marginRight: 20,
    '&::-webkit-scrollbar': {
      height: 5,
      borderRadius: 50,
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1' 

    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888' ,
      borderRadius: 10,

    }
  },
  colContainer: {
    display:'inline-block',
    borderRight: '1px solid #003a75',
    borderTop: '1px solid #003a75',
    borderBottom: '1px solid #003a75',
    width: 250,
    '&:last-child': {
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10,
      '& span': {
        borderTopRightRadius: 8,
      }
    },
    '&:nth-child(1)': {
      borderLeft: '1px solid #003a75',
      borderTopLeftRadius: 10,
      borderBottomLeftRadius: 10,
      '& span': {
        borderTopLeftRadius: 8,
      }
    },
    '& span': {
      width: '100%',
      display: 'flex',
      padding: '15px 20px 15px 20px',
      backgroundColor: '#004f9f',
      color: 'white',
      fontWeight: 'bold',
      justifyContent: 'center',
      
    }
    
  },
  colContainerItems: {
    padding: '10px 0',
    height: '100%',
    width: 250,
    backgroundColor:'transparent',
    zIndex: 10,
    transition: '0.2s'
  },
  stagedItem: {
    height: 0,
    width: 0,
    backgroundColor:'transparent',
    zIndex: 4,
    
  },

  add: {
    width: '100%',
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'rgba(0,0,0,0.5)',
    '&:hover': {
      color: 'rgba(0,0,0,0.8)'
    }
  }
  
})